import { callAPI } from '../network';

export async function getAirports (companyId){
  
   const data = await callAPI(
                        null, 
                        'Airport/GetByCompanyId?companyId=' + companyId, 'get');
   return data || [ ];
}
